<template>
  <div id="register">
    <section>
      <form @submit.stop.prevent="onSubmit">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 col-md-6 p-0">
              <img src="./../../assets/images/register.png" class="w-100" />
            </div>
            <div class="col-12 col-md-6 px-lg-5">
              <div class="row">
                <div class="col-12 text-center pt-lg-5 mt-4">
                  <h1 class="pb-4 font-h4">
                    <b>{{ $t("pages.regisAgent") }}</b>
                  </h1>
                  <p class="pb-4">
                    {{ $t("pages.regisAgentFillin") }}
                  </p>
                </div>
                <div class="col-12 col-lg-6 pb-4">
                  <b-form-input
                    id="firstName"
                    name="firstName"
                    v-model="form.firstName"
                    v-validate="{ required: true }"
                    :state="validateState('firstName')"
                    v-bind:placeholder="$t('pages.regisFirstName')"
                  ></b-form-input>
                </div>
                <div class="col-12 col-lg-6 pb-4">
                  <b-form-input
                    id="lastName"
                    name="lastName"
                    v-model="form.lastName"
                    v-validate="{ required: true }"
                    :state="validateState('lastName')"
                    v-bind:placeholder="$t('pages.regisLastName')"
                  >
                  </b-form-input>
                </div>
                <div class="col-12 col-lg-6 pb-4">
                  <b-form-input
                    id="email"
                    name="email"
                    v-model="form.email"
                    v-validate="{ required: true, email: true }"
                    :state="validateState('email')"
                    v-bind:placeholder="$t('pages.regisEmail')"
                  >
                  </b-form-input>
                </div>
                <div class="col-12 col-lg-6 pb-4">
                  <b-form-input
                    id="mobile"
                    name="mobile"
                    v-model="form.mobile"
                    v-validate="{ required: true, min: 10, max: 10 }"
                    :formatter="numberFormat"
                    :state="validateState('mobile')"
                    v-bind:placeholder="$t('pages.regisPhone')"
                  >
                  </b-form-input>
                </div>
                <div class="col-12 col-lg-6 pb-4">
                  <b-form-group>
                    {{ $t("pages.regisPleaseSelect") }}
                    <b-form-radio-group
                      id="agentType"
                      v-model="form.agentType"
                      name="agentType"
                      v-validate="{ required: true }"
                      :state="validateState('agentType')"
                    >
                      <b-form-radio value="A" class="pl-0">{{
                        $t("pages.regisAgency")
                      }}</b-form-radio>
                      <b-form-radio value="f" class="pl-0">{{
                        $t("pages.regisFreelance")
                      }}</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </div>
                <div class="col-12 col-lg-6 pb-4">
                  <div class="pt-lg-4">
                    <b-form-input
                      id="company"
                      name="company"
                      v-model="form.company"
                      :disabled="form.agentType == 'f' ? true : false"
                      :state="validateState('company')"
                      v-bind:placeholder="$t('pages.regisAgencyName')"
                      v-validate="{
                        required:
                          !form.agentType || form.agentType == 'A'
                            ? true
                            : false,
                      }"
                    >
                    </b-form-input>
                  </div>
                </div>
                <div class="col-12">
                  <p class="mb-2">
                    <b>{{ $t("pages.regisLabelQuestion") }}</b>
                    {{ $t("pages.regisLabelQuestion1") }}
                  </p>
                </div>
                <div class="col-6 col-lg-auto">
                  <b-form-checkbox
                    value="S"
                    unchecked-value=""
                    v-model="form.S"
                  >
                    {{ $t("pages.regisAgentsForSale") }}
                  </b-form-checkbox>
                </div>
                <div class="col-6 col-lg-auto">
                  <b-form-checkbox
                    value="R"
                    unchecked-value=""
                    v-model="form.R"
                  >
                    {{ $t("pages.regisAgentsForRent") }}
                  </b-form-checkbox>
                </div>
                <div class="col-6 col-lg-auto">
                  <b-form-checkbox
                    value="IR"
                    unchecked-value=""
                    v-model="form.IR"
                  >
                    {{ $t("pages.regisInterestedToRent") }}
                  </b-form-checkbox>
                </div>
                <div class="col-6 col-lg-auto">
                  <b-form-checkbox
                    value="IS"
                    unchecked-value=""
                    v-model="form.IS"
                  >
                    {{ $t("pages.regisInterestedToBuy") }}
                  </b-form-checkbox>
                </div>
                <div class="col-12 border-top border-2 my-4"></div>
                <div class="col-12">
                  <b-form-checkbox
                    id="checkedTerm"
                    v-model="form.checkedTerm"
                    name="checkedTerm"
                    value="accepted"
                    unchecked-value=""
                    v-validate="{ required: true }"
                    :state="validateState('checkedTerm')"
                  >
                    <u>{{ $t("pages.regisAgree") }}</u>
                  </b-form-checkbox>
                </div>
                <div class="col-12 my-5 text-center">
                  <button class="btn btn-primary" type="submit">
                    {{ $t("pages.register") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </section>
    <section>
      <b-modal id="modal-save" centered>
        <template v-slot:modal-header="{ close }">
          <h2 class="text-right w-100 mb-0">
            <img
              src="./../../assets/images/icon/close.png"
              width="25"
              class="cursor-pointer"
              @click="close()"
            />
          </h2>
        </template>

        <template v-slot:default>
          <div class="text-center" v-html="msgSave"></div>
          <div class="text-center">
            <router-link to="/" tag="button" class="btn btn-primary mt-2 mb-5"
              >กลับหน้าหลัก</router-link
            >
          </div>
        </template>
      </b-modal>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msgSave: "",
      form: {
        firstName: null,
        lastName: null,
        email: null,
        mobile: null,
        agentType: null,
        company: null,
        checkedTerm: "",
        S: "",
        R: "",
        IR: "",
        IS: "",
      },
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.$veeFields[ref] &&
        (this.$veeFields[ref].dirty || this.$veeFields[ref].validated)
      ) {
        return !this.$veeErrors.has(ref);
      }
      return null;
    },
    onSubmit() {
      let interestingChoice = [
        this.form.S,
        this.form.R,
        this.form.IR,
        this.form.IS,
      ];
      interestingChoice = interestingChoice
        .filter((value) => value.length > 0)
        .join(",");
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return;
        }
        let loading = this.$loading.show();
        const formData = new FormData();
        formData.append("firstName", this.form.firstName);
        formData.append("lastName", this.form.lastName);
        formData.append("email", this.form.email);
        formData.append("mobile", this.form.mobile);
        formData.append("agentType", this.form.agentType);
        formData.append("company", this.form.company);
        formData.append("interestingChoice", interestingChoice);
        formData.append("password", "");
        this.$http
          .post(this.$app.baseURL + this.$path.userRegister, formData)
          .then(
            (res) => {
              loading.hide();
              this.$bvModal.show("modal-save");
              if (res.data.status == 200) {
                this.msgSave =
                  '<h4><b>ขอบคุณ</b></h4><div class="py-4">คุณได้ทำการลงทะเบียน กับ Rental Agentcloud<br><b> ทาง Rental Agentcloud จะติดต่อกลับคุณไปทางอีเมลที่คุณ<br>ได้ทำการลงทะเบียนไว้ เพื่อยืนยันการลงทะเบียนที่สมบูรณ์</b></div>';
              } else {
                this.msgSave =
                  '<h4><b>คุณไม่สามารถลงทะเบียนได้</b></h4><div class="py-4">เนื่องจาก Account นี้ได้มีการลงทะเบียนไว้แล้ว<br>หรือ Account นี้กำลังรอการยืนยันการลงทะเบียนอย่างสมบูรณ์จากทางเจ้าหน้าที่</div>';
              }
              this.resetForm();
            },
            () => {
              loading.hide();
              this.$bvModal.show("modal-save");
              this.msgSave =
                '<h4><b>คุณไม่สามารถลงทะเบียนได้</b></h4><div class="py-4">เนื่องจาก Account นี้ได้มีการลงทะเบียนไว้แล้ว<br>หรือ Account นี้กำลังรอการยืนยันการลงทะเบียนอย่างสมบูรณ์จากทางเจ้าหน้าที่</div>';
              this.resetForm();
            }
          );
      });
    },
    resetForm() {
      this.form = {
        firstName: null,
        lastName: null,
        email: null,
        mobile: null,
        agentType: null,
        company: null,
        checkedTerm: "",
        S: "",
        R: "",
        IR: "",
        IS: "",
      };
      this.$nextTick(() => {
        this.$validator.reset();
      });
    },
    numberFormat(value) {
      return value.replace(/[^0-9]+/g, "");
    },
  },
};
</script>

<style scoped>
</style>